import { LoadIndicator } from 'devextreme-react';

interface ConfigLoadingProps {
  /** Texto a mostrar. Por defecto, un mensaje genérico de carga. */
  message?: string;
  height?: number | string;
}

/**
 * Estado de carga para módulos que dependen de las listas de GetAllConfig.
 * Se muestra en lugar del contenido real mientras el payload no ha llegado,
 * para evitar formularios sin campos o combos vacíos.
 */
export const ConfigLoading = ({ message = 'Cargando configuración del sistema...', height = 200 }: ConfigLoadingProps) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '12px',
      height,
      width: '100%',
    }}>
    <LoadIndicator visible={true} height={32} width={32} />
    <span style={{ color: '#888', fontSize: '13px' }}>{message}</span>
  </div>
);

export default ConfigLoading;
